import { render, staticRenderFns } from "./Pertanyaan.vue?vue&type=template&id=6173a75d&"
import script from "./Pertanyaan.vue?vue&type=script&lang=js&"
export * from "./Pertanyaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports